/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BusinessProfile =
  | 'BUYER'
  | 'SUPPLIER';

export type CreateGroupChannelMutationVariables = Exact<{
  buyingCompanyId: string;
  supplyingCompanyId: string;
  fromBusinessProfile: Types.BusinessProfile;
}>;


export type CreateGroupChannelMutation = { createGroupChannel: { channelUrl: string } };


export const CreateGroupChannelDocument = /*#__PURE__*/ gql`
    mutation CreateGroupChannel($buyingCompanyId: uuid!, $supplyingCompanyId: uuid!, $fromBusinessProfile: BusinessProfile!) {
  createGroupChannel(
    buyingCompanyId: $buyingCompanyId
    supplyingCompanyId: $supplyingCompanyId
    fromBusinessProfile: $fromBusinessProfile
  ) {
    channelUrl
  }
}
    `;
export type CreateGroupChannelMutationFn = Apollo.MutationFunction<CreateGroupChannelMutation, CreateGroupChannelMutationVariables>;

/**
 * __useCreateGroupChannelMutation__
 *
 * To run a mutation, you first call `useCreateGroupChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupChannelMutation, { data, loading, error }] = useCreateGroupChannelMutation({
 *   variables: {
 *      buyingCompanyId: // value for 'buyingCompanyId'
 *      supplyingCompanyId: // value for 'supplyingCompanyId'
 *      fromBusinessProfile: // value for 'fromBusinessProfile'
 *   },
 * });
 */
export function useCreateGroupChannelMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupChannelMutation, CreateGroupChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupChannelMutation, CreateGroupChannelMutationVariables>(CreateGroupChannelDocument, options);
      }
export type CreateGroupChannelMutationHookResult = ReturnType<typeof useCreateGroupChannelMutation>;
export type CreateGroupChannelMutationResult = Apollo.MutationResult<CreateGroupChannelMutation>;
export type CreateGroupChannelMutationOptions = Apollo.BaseMutationOptions<CreateGroupChannelMutation, CreateGroupChannelMutationVariables>;